import { Injectable } from '@angular/core';
import { EventHoveringArg } from '@fullcalendar/core';
import {
  EventExtendedProps,
  ResourcesManagerService,
} from '@sc/feature-fitter-shared-libs';
import { FeatureFlippingManagerService } from '@sc/feature-flipping';
import tippy, { Instance, followCursor } from 'tippy.js';
import {
  TooltipGenericEventService,
  TooltipInCenterService,
  TooltipOutsideService,
  TooltipReplacementVehicleService,
} from './types';

@Injectable({ providedIn: 'root' })
export class PlanningTooltipMakerService {
  _tippy: Instance;

  constructor(
    private readonly tooltipGenericEventService: TooltipGenericEventService,
    private readonly tooltipInCenterService: TooltipInCenterService,
    private readonly tooltipOutsideService: TooltipOutsideService,
    private readonly tooltipReplacementVehicleService: TooltipReplacementVehicleService,
    private readonly featureFlippingService: FeatureFlippingManagerService,
    private readonly resManagerService: ResourcesManagerService
  ) {}

  display(info: EventHoveringArg, forceOnClickDisplay = false) {
    if (this._tippy) {
      this._tippy.destroy();
    }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this._tippy = tippy(info.el, {
      content: this.generateToolTip(info),
      allowHTML: true,
      followCursor: true,
      trigger: forceOnClickDisplay ? 'click focus' : 'mouseenter',
      hideOnClick: true,
      plugins: [followCursor],
    });
  }

  private generateToolTip(info: EventHoveringArg) {
    const displaySimplified = this.featureFlippingService.isFeatureActivated(
      'agenda-simplify-dossier-tooltip'
    );

    const extendedProps = info.event.extendedProps as EventExtendedProps;
    if (this.resManagerService.isDossierEventExtendedProps(extendedProps)) {
      const eventResource = info.event.getResources()[0];
      const eventResType = this.resManagerService.getResourceType(
        eventResource?.id
      );

      if (this.resManagerService.isAnyRVRes(eventResType)) {
        return this.tooltipReplacementVehicleService.generateToolTip(
          info,
          displaySimplified
        );
      } else if (this.resManagerService.isAnyOutsideRes(eventResType)) {
        return this.tooltipOutsideService.generateToolTip(
          info,
          displaySimplified
        );
      } else if (this.resManagerService.isAnyCenterRes(eventResType)) {
        return this.tooltipInCenterService.generateToolTip(
          info,
          displaySimplified
        );
      }
    } else {
      return this.tooltipGenericEventService.generateToolTip(
        info,
        displaySimplified
      );
    }
  }
}
